module.exports = __webpack_public_path__ + "img/kmitl-osda.4fc99403.png";